// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RHi-","colBig":"styles_colBig__L5Mdc","colSmall":"styles_colSmall__2D_NO"};